import * as React from 'react';
import type { BlockedProductIndicators } from 'contracts/blocked-products';
import { Skeleton } from 'components/ui/skeleton';
import { cn } from 'lib/utils';
import { Formatter } from 'utils';

import {
  IndicatorBadge,
  IndicatorBody,
  IndicatorHeader,
  IndicatorFooter,
  IndicatorHighlight,
  IndicatorRoot,
  IndicatorTitle,
} from './primitives';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  indicators?: BlockedProductIndicators;
  loading?: boolean;
}

export const Indicators = ({ indicators, loading, className }: Props) => {
  if (!indicators || loading) {
    return (
      <div className={cn('flex gap-4', className)}>
        <IndicatorSkeleton />
        <IndicatorSkeleton />
        <IndicatorSkeleton />
      </div>
    );
  }

  const { totalValue, totalBlockedProducts, totalBlockedStock, estimatedTime } = indicators;

  return (
    <div className={cn('flex gap-4', className)}>
      <IndicatorRoot>
        <IndicatorHeader>
          <IndicatorTitle>Valor total</IndicatorTitle>
        </IndicatorHeader>
        <IndicatorBody>
          <IndicatorHighlight>{Formatter.currency(totalValue, 'USD')}</IndicatorHighlight>
        </IndicatorBody>
        <IndicatorFooter>
          <IndicatorBadge>{totalBlockedProducts} Produtos</IndicatorBadge>
        </IndicatorFooter>
      </IndicatorRoot>

      <IndicatorRoot>
        <IndicatorHeader>
          <IndicatorTitle>Tempo estimado</IndicatorTitle>
        </IndicatorHeader>
        <IndicatorBody>
          <IndicatorHighlight>{estimatedTime} D</IndicatorHighlight>
        </IndicatorBody>
        <IndicatorFooter>
          <IndicatorBadge>{totalBlockedProducts} Produtos</IndicatorBadge>
        </IndicatorFooter>
      </IndicatorRoot>

      <IndicatorRoot>
        <IndicatorHeader>
          <IndicatorTitle>Quantidade</IndicatorTitle>
        </IndicatorHeader>
        <IndicatorBody>
          <IndicatorHighlight>{Formatter.decimal(totalBlockedStock)}</IndicatorHighlight>
        </IndicatorBody>
        <IndicatorFooter>
          <IndicatorBadge>{totalBlockedProducts} Produtos</IndicatorBadge>
        </IndicatorFooter>
      </IndicatorRoot>
    </div>
  );
};

const IndicatorSkeleton = () => {
  return (
    <IndicatorRoot>
      <IndicatorBody className={'flex flex-col gap-3'}>
        <Skeleton className={'w-[120px] h-4'} />
        <Skeleton className={'w-[60px] h-4'} />
        <Skeleton className={'w-[120px] h-4'} />
      </IndicatorBody>
    </IndicatorRoot>
  );
};